<div class="tree-chart-container">
  <!-- Zoom toolbar -->
  @if (zoomEnabled()) {
    <div class="tree-chart-toolbar">
      <button class="tree-chart-toolbar__btn" (click)="fitToScreen()" title="Fit to screen">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            d="M1 4V1.5a.5.5 0 0 1 .5-.5H4M10 1h2.5a.5.5 0 0 1 .5.5V4M13 10v2.5a.5.5 0 0 1-.5.5H10M4 13H1.5a.5.5 0 0 1-.5-.5V10"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <div class="tree-chart-toolbar__divider"></div>
      <button class="tree-chart-toolbar__btn" [disabled]="zoomOutDisabled()" (click)="zoomOut()" title="Zoom out">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <circle cx="6" cy="6" r="4.5" stroke="currentColor" stroke-width="1.4" />
          <path d="M9.5 9.5 13 13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
          <path d="M4 6h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
        </svg>
      </button>
      <button class="tree-chart-toolbar__percentage" (click)="fitToScreen()" title="Reset to 100%">
        {{ zoomPercentage() }}
      </button>
      <button class="tree-chart-toolbar__btn" [disabled]="zoomInDisabled()" (click)="zoomIn()" title="Zoom in">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <circle cx="6" cy="6" r="4.5" stroke="currentColor" stroke-width="1.4" />
          <path d="M9.5 9.5 13 13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
          <path d="M4 6h4M6 4v4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
        </svg>
      </button>
    </div>
  }

  <div
    echarts
    class="tree-chart"
    [options]="chartOptions()"
    [initOpts]="initOpts"
    [autoResize]="true"
    (chartInit)="onChartInit($event)"
  ></div>

  @for (a of latexAnnotations(); track a.id) {
    <span
      class="tree-latex-label"
      [class.tree-latex-label--leaf]="a.isLeaf"
      [style.left.px]="a.left"
      [style.top.px]="a.top"
      [innerHTML]="a.html"
    ></span>
  }
</div>
